import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { debounce, later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import hasMany from "cc-frontend/helpers/has-many"

export default class TimelineWrapperComponent extends Component {
  @service("ember-store")
  store

  @service
  appState

  barHeight = 40
  dateWidth = 20
  dateBarHeight = 55

  @hasMany("planbook", "course", "courses")
  courses

  showUnits = false

  didInsertElement() {
    super.didInsertElement(...arguments)
    later(() => {
      if (this.isDestroyed || this.isDestroying) return
      set(this, "showUnits", true)
    }, 15)
  }

  @action
  clickedDate(dateString) {
    set(this, "date", dateString)
  }

  @action
  updateDateWidth(width) {
    debounce(this, () => set(this, "dateWidth", width), 15)
  }

  @action
  incWidth() {
    set(this, "dateWidth", Math.floor(get(this, "dateWidth")) + 1)
  }

  @action
  decWidth() {
    set(this, "dateWidth", Math.floor(get(this, "dateWidth")) - 1)
  }
}
